export const albumArtMapping: Record<string, string> = {
  '1': 'kendrick-lamar-alright.png',
  '3': 'lil-baby-bigger-picture.jpeg',
  '4': 'gary-clark-jr-this-land.jpeg',
  '5': 'beyonce-formation.jpeg',
  '6': 'bruce-springsteen-born-usa.jpg',
  '7': 'rage-against-machine-killing.jpg',
  '8': 'gil-scott-heron-revolution.jpeg',
  '9': 'noize-mc-lebedinoye-ozero.webp',
  '10': 'monetochka-rossii.png',
  '11': 'mabel-matiz-perperisan.jpg',
  '12': 'jon-batiste-petrichor.webp',
  '13': 'cielo-magno-tax.jpg',
  '14': 'neil-young-big-crime.jpg',
  '15': 'softcult-she-said-he-said.jpg',
  '16': 'mat-ward-small-dick-energy.jpg',
  '17': 'blak-rapp-madusa-gendercide.jpeg',
  '18': 'lisa-oneill-wind.jpg',
  '19': 'baker-boy-thick-skin.jpg',
  '20': 'agiftfromtodd-hostile-takeover.jpeg',
  '21': 'octopizzo-june-25th.jpeg',
  '22': 'mr-d-bandai-chha-nepal.jpeg',
  '23': 'midnight-oil-beds-burning.jpg',
  '24': 'snow-tha-product-alligator.jpeg',
  '25': 'stan-walker-mo-ake-tonu.jpeg',
  '26': 'earth-to-eve-threat-level.jpeg',
  '27': 'osibisa-woyaya.jpg',
  '28': 'daniel-hamrick-boy.jpg',
  '29': 'jpegmafia-protect-cross.jpeg',
  '30': 'public-enemy-march-madness.jpg',
  '31': 'michael-jackson-they-dont-care.jpg',
  '32': 'fiona-apple-pretrial.jpeg',
  '33': 'neil-young-lets-roll-again.jpg',
  '34': 'beyonce-ameriican-requiem.jpg',
  '35': 'kneecap-recap.jpeg',
  '36': 'jesse-welles-red.jpeg',
  '37': 'jesse-welles-united-health.jpeg',
  '38': 'paris-paloma-labour.jpg',
  '39': 'jesse-welles-war-isnt-murder.jpeg',
  '40': 'oliver-anthony-rich-men.jpeg',
  '41': 'pete-seeger-solidarity-forever.jpeg',
  '42': 'anonymous-glory-hong-kong.jpg',
  '43': 'anonymous-fate.png',
  '44': 'childish-gambino-this-is-america.jpg',
};
